import { render, staticRenderFns } from "./CampaignDetail.vue?vue&type=template&id=58c64c46&scoped=true&"
import script from "./CampaignDetail.vue?vue&type=script&lang=js&"
export * from "./CampaignDetail.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetail.vue?vue&type=style&index=0&id=58c64c46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c64c46",
  null
  
)

export default component.exports